/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceRules } from './sequenceRules';
import type { SequenceSchedule } from './sequenceSchedule';

/**
 * Body for ``POST /api/jobs/{job_id}/sequences``.
 */
export interface SequenceCreate {
  /**
     * @minLength 1
     * @maxLength 255
     */
  name: string;
  description?: string | null;
  sender_user_id: string;
  mailbox_id: string;
  schedule?: SequenceSchedule;
  rules?: SequenceRules;
}
